(function () {
    'use strict';

    angular.module("imApp").factory("orderLineCreditCausesService", ['$ihttp', function ($ihttp) {
        let service = {
            listOrderLineCreditCauses: function (parms) {
                return $ihttp.post({
                    method: 2762,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
